class Shelf {

	static formatServerData(data) {
		return {
			id: data.id,
			name: data.name,
			books: data.objects || [],
			category: data.category
			// createdAt: item.date_created
		}
	}

	// vm - vue model
	/*constructor(vm, id) {
		this.vm = vm;
		this.ID_SHELF = id;
		this.events = {};
	}

	$emit(name, data = null) {
		this.events[name]?.(data);
	}

	$on(name, callback) {
		this.events[name] = callback;
	}

	edit() {

		this.$emit('edit', {
			id: '!!!'
		});

		// this.vm.$vfm.show({component: ShelfModal}, {
		// 	idShelf: this.ID_SHELF,
		// 	category: {id: 1},
		// 	onSuccess: (mode, data) =>
		// });
	}*/
}

export default Shelf;